import Tabs from "devextreme-react/tabs";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../../contexts/auth";
import { useTitle } from "../../../../contexts/title";
import { AR, CompanyTypes, OrderStatus } from "../../../../types/enums";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";
import { PurchaseOrderProgressStepInfo } from "../types/PurchaseOrderProgressStepInfo";

export default function PurchaseOrderProgress() {

	const { order } = useContext(PurchaseOrderContext);

	const location = useLocation();
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const resolvedIcon = 'dx-icon dx-icon-Inscyth-Checked-Box';
	const unresolvedIcon = '';

	const { user } = useAuth();
	const isManufacturer = user?.companyTypeId === CompanyTypes.MFR;
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;
	const urlFolder = isManufacturer ? "manufacturer" : isServiceProvider ? "service-provider" : "distributor";

	var steps: PurchaseOrderProgressStepInfo[] = isServiceProvider ?
		[
			{
				text: 'Info',
				navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID,
				visible: true,
				disabled: false,
				icon: 'dx-icon dx-icon-info'
			},
			{
				text: 'Service Date',
				navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/370',
				visible: true,
				disabled: false,
				icon: order.details.resolvedARs.includes(AR.POServiceProviderToEnterServiceDate) ? resolvedIcon : unresolvedIcon
			},
			{
				text: 'Invoice',
				navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/380',
				visible: true,
				disabled: (!order.details.resolvedARs.includes(AR.POServiceProviderToInvoice) &&
					!order.details.activeARs.includes(AR.POServiceProviderToInvoice)),
				icon: order.details.resolvedARs.includes(AR.POServiceProviderToInvoice) ? resolvedIcon : unresolvedIcon
			}
		]
		:
		order.details.deliveryFlow ?
			[
				{
					text: 'Info',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID,
					visible: true,
					disabled: false,
					icon: 'dx-icon dx-icon-info'
				},
				{
					text: 'Validate/Confirm Delivery Date',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/341',
					visible: true,
					disabled: false,
					icon: order.details.resolvedARs.includes(AR.PODistributorToValidateDeliveryDate) ? resolvedIcon : unresolvedIcon
				},
				{
					text: 'Delivery Details',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/351',
					visible: true,
					disabled: (!order.details.resolvedARs.includes(AR.PODistributorToEnterDeliveryDate) &&
						!order.details.activeARs.includes(AR.PODistributorToEnterDeliveryDate)),
					icon: order.details.resolvedARs.includes(AR.PODistributorToEnterDeliveryDate) ? resolvedIcon : unresolvedIcon
				},
				{
					text: 'Invoice',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/360',
					visible: !order.details.isSampleOrder,
					disabled: (!order.details.resolvedARs.includes(AR.PODistributorToInvoice) &&
						!order.details.activeARs.includes(AR.PODistributorToInvoice)),
					icon: order.details.resolvedARs.includes(AR.PODistributorToInvoice) ? resolvedIcon : unresolvedIcon
				}
			]
			:
			[
				{
					text: 'Info',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID,
					visible: true,
					disabled: false,
					icon: 'dx-icon dx-icon-info'
				},
				{
					text: 'Validate Ship Date',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/340',
					visible: true,
					disabled: false,
					icon: order.details.resolvedARs.includes(AR.PODistributorToValidateShipDate) ? resolvedIcon : unresolvedIcon
				},
				{
					text: 'Ship',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/350',
					visible: true,
					disabled: (!order.details.resolvedARs.includes(AR.PODistributorToEnterShipDate) &&
						!order.details.activeARs.includes(AR.PODistributorToEnterShipDate)),
					icon: order.details.resolvedARs.includes(AR.PODistributorToEnterShipDate) ? resolvedIcon : unresolvedIcon
				},
				{
					text: 'Invoice',
					navigateTo: `/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/360',
					visible: !order.details.isSampleOrder,
					disabled: (!order.details.resolvedARs.includes(AR.PODistributorToInvoice) &&
						!order.details.activeARs.includes(AR.PODistributorToInvoice)),
					icon: order.details.resolvedARs.includes(AR.PODistributorToInvoice) ? resolvedIcon : unresolvedIcon
				}
			];

	let selectedStep: PurchaseOrderProgressStepInfo | undefined;

	steps.forEach(step => {
		if (location.pathname.includes(step.navigateTo) && (!selectedStep || selectedStep.navigateTo < step.navigateTo)) {
			selectedStep = step;
		}
	});

	const pageTitle = useTitle();
	useEffect(() => {
		if (selectedStep) {
			pageTitle.setTitle(selectedStep?.text)
		}
	}, [pageTitle, selectedStep]);

	return (
		<Tabs
			className="order-progress"
			dataSource={steps}
			selectedItem={selectedStep}
			onItemClick={(e) => navigate(e.itemData?.navigateTo! + (!!returnUrl ? '?returnUrl=' + returnUrl : ''))}
		>

		</Tabs>
	);
}
